// v2.11.0 — PaymentMockModal : modale de paiement mock (préparation CinetPay).
// Affiche le montant + bouton "Payer (Mock)" → POST /api/payments/initiate
// → toast confirmation. Aucun vrai paiement.

import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentMockModal({ open, onClose, event, userId }) {
  const [loading, setLoading] = useState(false);
  if (!open || !event) return null;
  const amount = event.ticket_price_fcfa || 0;

  const onPay = async () => {
    setLoading(true);
    try {
      const r = await axios.post(`${API}/payments/initiate`, {
        userId,
        address_civ: event.address_civ,
        amount_fcfa: amount,
        label: `Ticket ${event.title}`,
      });
      toast.success(`🚧 Paiement en intégration — booking ${r.data.booking_id?.slice(0, 12)}`);
      onClose && onClose({ ok: true, booking_id: r.data.booking_id });
    } catch (e) {
      toast.error("Impossible d'initier le paiement");
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="payment-mock-modal"
      role="dialog"
      aria-modal="true"
      onClick={() => onClose && onClose({ ok: false, cancelled: true })}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(0,0,0,0.7)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#0f172a",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 16, padding: 24,
          maxWidth: 420, width: "100%",
          color: "#fff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ fontSize: 11, color: "#94a3b8", letterSpacing: "0.06em", marginBottom: 4 }}>RÉSERVATION</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0, lineHeight: 1.3 }}>{event.title}</h2>
        <div style={{ fontSize: 12, color: "#cbd5e1", marginTop: 6 }}>📍 {event.venue_name} · {event.commune}</div>

        <div style={{
          background: "rgba(245,158,11,0.12)",
          border: "1px solid rgba(245,158,11,0.3)",
          borderRadius: 10, padding: 14, marginTop: 18,
        }}>
          <div style={{ fontSize: 11, color: "#fbbf24", letterSpacing: "0.05em", fontWeight: 700 }}>MONTANT TICKET</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: "#fff", marginTop: 4 }}>
            {amount.toLocaleString("fr-FR")} <span style={{ fontSize: 14, color: "#fbbf24" }}>FCFA</span>
          </div>
        </div>

        <div style={{ fontSize: 11, color: "#fca5a5", marginTop: 14, lineHeight: 1.5 }}>
          🚧 <strong>Mode démo</strong> : l'intégration CinetPay réelle arrive bientôt. Cliquer enregistrera juste une intention de réservation.
        </div>

        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button
            onClick={() => onClose && onClose({ ok: false, cancelled: true })}
            data-testid="payment-cancel-btn"
            style={{
              flex: 1, background: "rgba(255,255,255,0.06)", color: "#cbd5e1",
              border: "1px solid rgba(255,255,255,0.12)",
              padding: "10px", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 13,
            }}
          >Annuler</button>
          <button
            onClick={onPay}
            disabled={loading}
            data-testid="payment-pay-btn"
            style={{
              flex: 2, background: loading ? "#94a3b8" : "#F59E0B", color: "#0f172a",
              border: "none", padding: "10px", borderRadius: 8,
              cursor: loading ? "wait" : "pointer", fontWeight: 800, fontSize: 13,
            }}
          >{loading ? "…" : `🎟 Payer ${amount.toLocaleString("fr-FR")} FCFA (Mock)`}</button>
        </div>
      </div>
    </div>
  );
}
